import { useAccountProperty } from "src/hooks/me"
import { GlucoseUnit } from "src/types"

export function useGlucoseUnit() {
  return useAccountProperty(
    "units",
    GlucoseUnit.MilligramsPerDeciliter,
  )
}
